import { DeleteOutlined, EditOutlined} from "@ant-design/icons";
import { Table, Select, Empty, Button} from "antd";
import moment from "moment";
import {useContext, useEffect, useState} from "react";
import { Icon } from "semantic-ui-react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { useGestionLineasCategorias } from "../../../../hooks/useGestionLineasCategorias";
import { LineaConvocatoria } from "../../../../models/Maestras/maestras.model";
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalLineaCategorias } from "./ModalLineaCategorias";
import {TemplateContext} from "../../../../utils/template_context";
import { BreadCrumbAdmin } from '../../../../components/Administrador/Breadcrumb/Breadcrumb';
import { itemRenderTable } from "../../../../utils/itemRenderTable";

export const GestionLineasCategorias = () => {

    const {
        cantidadpaginas,
        cambiarCantidadPaginas,
        getLineasConvocatorias,
        lineasConvocatorias
    } = useGestionLineasCategorias();
    const context = useContext(TemplateContext);
    useEffect(() => {
        let mounted = true;

        if (mounted) {
            getLineasConvocatorias();
        }
        return () => {
            mounted = false;
        }
    }, [])

    const columns: any = [
        {
            title: "No.",
            width: 10,
            key: "idx",
             fixed: context.device === "md"? "left": false,
            render: (datos: LineaConvocatoria, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: "Fecha creación",
            key: "fecha_creacion",
             fixed: context.device === "md"? "left": false,
            width: 150,
            render: (datos: LineaConvocatoria, record: any, index: number) => (
                <div>{moment(datos.fecha_creacion).format("DD/MM/YYYY")}</div>
            )
        },
        {
            title: "Nombre línea",
            key: "nombre",
            dataIndex: "nombre",
             fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: LineaConvocatoria, record: any, index: number) => (
                <div className="controls">
                    <EditOutlined onClick={() => modalEditar(datos)} />
                    <DeleteOutlined onClick={() => deleteLC(datos)} />
                </div>
            )
        },
    ]



    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [lineaConvocatoria, setLineaConvocatoria] = useState<LineaConvocatoria>({
        nombre: ''
    })

    const deleteLC = async (datos: LineaConvocatoria) => {
        try {
            let { id } = datos;

            const data = await apiMaestras.eliminarLineaConvocatoria(id);
            //console.log(data)
            if (!data.ok) {
                return openNotification({
                    titulo: "Error",
                    descripcion: data.message,
                    placement: "bottomRight",
                })
            }
            getLineasConvocatorias();
        } catch (error) {
            console.log(error);
        }
    }

    const modalEditar = (datos: LineaConvocatoria) => {
        setLineaConvocatoria(datos)
        setOpenModal(true);
        setIsEdit(true);
    }

    const crearLC = () => {
        setOpenModal(true);
        setIsEdit(false);
    }

    const routes = [{ nombre: "Administración" },{ nombre: "Gestionar maestras" },{ nombre: "Convocatorias", to: '/administrador/gestionMaestras' },{ nombre: "líneas y categorías" }]



    return (


        <div className="background-color-F7FBFF height-100">
            <BreadCrumbAdmin routes={routes} />
            <div className="container-fluid ps-md-4 pe-md-4 main-c2" >
                
                <div className="d-flex justify-content-between title_out_card pe-0" >

                    <div className="font-family-Montserrat-SemiBold font-size-14px">
                        Gestionar líneas y categorías
                    </div>
                    <div className="d-flex justify-content-end align-items-center">

                        <Button className="no-margin button-azul-ghost justify-content-end" onClick={crearLC}>
                            Crear
                            <Icon className="ps-2" size="large" name="plus circle" />
                        </Button>
                    </div>

                </div>


                <div className="sombra_card" style={{ marginBottom: "50px" }}>

                    
                    <div className="body_card">
                        <div className="row">


                            <div className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular">

							Lista de líneas y categorías

                            </div>
                            <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                                <div className="d-flex justify-content-end pe-3">
                                    <div>
                                        Total: <span className="font-color-F28C02 ">{lineasConvocatorias.length}</span>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end align-content-center registos-adminconvocatoria">
                                    
                                    

                                   <div className="registros__paginas d-flex align-items-center align-content-center">
                        <span className="span__registros font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2">Registros por página</span>
                        <span className="select_paginador">
                        <Select defaultValue={10}  className="select__pag ant-select ant-select-enabled ant-select-sm" onChange={(e, { value }: any) => cambiarCantidadPaginas(e, value)}>
                        
                            {cantidadRegistros.map(({ text, value },i) =>
                                <Select.Option key={value} value={value}>{text}</Select.Option>
                            )}
                        </Select>
                        </span>
                        
                    </div>
                                </div>
                            </div>




                        </div>

                        <div className="col-12">
                            <div className="row">
                                <div className="col">
                                    <Table
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        columns={columns}
                                        dataSource={lineasConvocatorias}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadpaginas }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {openModal &&
                    <ModalLineaCategorias
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                        isEdit={isEdit}
                        datos={lineaConvocatoria}
                        getLineasConvocatorias={getLineasConvocatorias}
                    />
                }
            </div>
            </div>


            )
}


